/**
 * StampmatS product logo — used in app headers and page titles.
 * Renders the working logo (wordmark + stamp + chain) from /stampmats-logo.png,
 * served from pwa/public. Transparent background, 587x259 source, displayed at
 * 48px height by default; pass className with your own height utility (for
 * example "h-8 md:h-9") to override the size.
 */
export function Logo({ className = "h-12" }: { className?: string }) {
  return (
    <img
      src="/stampmats-logo.png"
      alt="StampmatS"
      className={`w-auto select-none ${className}`}
      draggable={false}
    />
  );
}
